export type { VideoSourceProps, VideoProps } from './types'

export { default } from './Video'
